<template>
    <!-- 地图浮云框（单实例） -->
    <div class="map-popup emap-map-popup-content">
        <main>
            <!-- 标题 -->
            <header>
                <!-- 标题 -->
                <div class="title">
                    <slot name="title">详情</slot>
                </div>
                <!-- 工具栏 -->
                <span class="ctrls">
                    <slot name="ctrls" />
                </span>
                <!-- 关闭按钮 -->
                <!-- <i class="close" @click="onClose" title="关闭" /> -->
                <i-Icon type="md-close" color="#515a6e" :size="18" @click="onClose" title="关闭"/>
            </header>
            <!-- 内容 -->
            <article><slot /></article>
        </main>
        <!-- 底部角 -->
        <footer />
    </div>
</template>

<script>
// Popup内容渲染组件
export const Render = {
    functional: true,
    render(h, context) {
        const Comp = context.parent.popupRequest.default;
        if (!Comp) return;

        const { feature,fields=[] } = context.parent.popupRequest;
        const options = Comp.options || {};
        return <Comp feature={feature} fields={fields} {...options} />;
    },
};

export default {
    inject: ['MapView'],
    methods: {
        onClose() {
            this.$emit('on-close');
            this.MapView.closePopup();
        },
    },
};
</script>
